import React from 'react';
import PropTypes from 'prop-types';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import RatioOverflowTableWrapper from "../../../components/styled-components/ratio-overflow-table-wrapper/RatioOverflowTableWrapper";

const DigitalSigningGroupsGrid = (props) => {
    const generateRow = (row) => {
        return (
            <TableRow key={row.id}>
                <TableRowColumn>{row.name}</TableRowColumn>
                <TableRowColumn>{row.description}</TableRowColumn>
                <TableRowColumn>{generateGroupOptionName(row)}</TableRowColumn>
                <TableRowColumn>
                    <div>
                        <a href="#" onClick={() => props.onEditClick(row)}>
                            <i className="small material-icons left themeprimarycolor">edit</i>
                        </a>
                        <a href="#" onClick={() => props.onSortClick(row)}>
                            <i className="small material-icons left themeprimarycolor">arrow_upward</i>
                        </a>
                        <a href="#" onClick={() => props.onAddClick(row)}>
                            <i className="small material-icons left themeprimarycolor">add</i>
                        </a>
                        <a href="#" onClick={() => props.onDeleteClick(row)}>
                            <i className="small material-icons left themeprimarycolor">clear</i>
                        </a>
                    </div>
                </TableRowColumn>
            </TableRow>
        );
    };

    const generateHeader = () => {
        return (
            props.headerNames.map(headerName =>
                <TableHeaderColumn key={headerName} headername={headerName} >
                    {headerName}
                </TableHeaderColumn>
            )
        );
    };

    const generateGroupOptionName = (row) => {
        if (row.isDigitalSigning) {
            return 'Digitaal ondertekenen';
        }

        return row.fieldSettings;
    };

    return (
        <RatioOverflowTableWrapper>
            <div className="valign-wrapper">
                <Table selectable={false}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow onCellClick = {props.onHeaderClick}>
                            {
                                generateHeader()
                            }
                        </TableRow>
                    </TableHeader>

                    <TableBody displayRowCheckbox={false}>
                        {
                            props.rows.map(row => generateRow(row))
                        }
                    </TableBody>
                </Table>
            </div>
        </RatioOverflowTableWrapper>
    );
};

DigitalSigningGroupsGrid.propTypes = {
    onEditClick: PropTypes.func.isRequired,
    getPropertyNameFromDisplayName: PropTypes.func.isRequired,
    rows: PropTypes.array.isRequired,
    headerNames: PropTypes.array.isRequired
};

export default DigitalSigningGroupsGrid;